<template>
    <div>
        <v-row class="px-2 pt-2">
            <v-col md="4" class="py-0">
                <v-autocomplete
                    v-model="merchant"
                    label="Select a merchant"
                    :items="merchants"
                    item-value="uuid"
                    item-text="name"
                    dense
                    return-object
                    clearable
                    @change="getReport(); loading = true;"
                    @click:clear="clearMerchant()"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row class="px-4">
            <v-col md="12" class="pa-2">
                <v-data-table
                    v-if="report"
                    :headers="headers"
                    :items="report"
                    :items-per-page="10"
                    class="elevation-0"
                >
                    <template v-slot:item.channelState="{ item }">

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon
                                    v-if="stateCheck(item)"
                                    x-small
                                    color="success"
                                    v-on="on"
                                >
                                mdi-circle
                                </v-icon>
                                <v-icon
                                    v-else
                                    x-small
                                    color="error"
                                    v-on="on"
                                >
                                mdi-circle
                                </v-icon>
                            </template>
                            Division: {{ item.divisionState}}<br>
                            Merchant: {{ item.merchantState}}<br>
                            Channel: {{ item.channelState}}
                        </v-tooltip>
                    </template>

                    <template v-slot:item.threeDSecure="{ item }">
                        {{ item.threeDSecure == 1 ? 'Yes' : 'No'  }}
                    </template>
                     <template v-slot:item.subTypes="{ item }">
                        {{ removeDuplicates(item) }}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            merchants: null,
            merchant: {},
            loading: true,
            report: null,
            headers: [{ text: 'State', value: 'channelState', sortable: false, align: "center" },
                      { text: 'Division', value: 'division', sortable: false },
                      { text: 'Merchant', value: 'merchant', sortable: false },
                      { text: 'Channel', value: 'channel', sortable: false },
                      { text: 'Acquirer', value: 'clearingInstitute', sortable: false },
                      { text: 'Merchant ID', value: 'merchantId', sortable: false, width: 120 },
                      { text: 'MCC', value: 'mcc', sortable: false },
                      { text: 'Recurring', value: 'recurringCode', sortable: false },
                      { text: '3D Secure', value: 'threeDSecure', align: 'center', sortable: false, width: 100 },
                      { text: 'Visa BIN', value: 'visaBin', sortable: false, align: "left", width: 100 },
                      { text: 'Master BIN', value: 'masterBin', sortable: false, align: "left", width: 100 },
                      { text: 'Currencies', value: 'currencies', sortable: false, align: "left" },
                      { text: 'Brands', value: 'subTypes', sortable: false, align: "left" },
                      { text: 'Sender ID', value: 'merchantUuid', sortable: false, align: "left" },
                      { text: 'Entity ID', value: 'channelUuid', sortable: false, align: "left" },
                      { text: 'Access Token', value: 'accessToken', sortable: false, align: "left" }]
        }
    },
    beforeMount() {
        this.getMerchants();
        this.getReport();
    },
    methods: {
        getMerchants() {
            axios({
            method: 'get',
            url: `get-merchants-live`,
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.merchants = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getReport() {
            axios({
            method: 'post',
            url: `full-merchant-data`,
            data: { merchant: typeof this.merchant !== 'undefined' ? this.merchant.uuid : null, gateId: 1 },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.report = response.data;
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        clearMerchant() {
            console.log(this.merchant);
        },
        removeDuplicates(e) {
            if(e) {
                let brands = e.subTypes.split(',').filter(function(item, pos, self) {
                    return self.indexOf(item) == pos;
                });
                return brands.sort().join();
            }
        },
        stateCheck(item) {
            if(item.divisionState == 'DISABLED') {
                return false;
            }
            else if(item.merchantState == 'DISABLED') {
                return false;
            }
            else if(item.channelState == 'DISABLED') {
                return false;
            }
            else {
                return true;
            }
        }
    }
}
</script>

<style>

</style>